import { configureStore } from '@reduxjs/toolkit';

import reducer from "./rootReducer";

// ==============================|| REDUX - MAIN STORE ||============================== //

const store = configureStore({
    reducer,
});

export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const usePageStore = (reducer: any) => {

}